import type { GetAllowedModulesQuery_get_allowed_modules_modules_admin as TalentModule } from '../../context/AdmindashboardContext/hooks/useGetAllowedModulesBySlug/graphql/types/GetAllowedModulesQuery';
import type { CardProps } from './components';

export const HomeEmptyBaseModule = {
  code: 'HOME',
  url: null,
  label: 'Inicio',
  submodules: [],
  __typename: 'TalentModuleInfo',
} as TalentModule;

export const EmptyTalentModulesArray = [HomeEmptyBaseModule];

export const performanceCompetencesModule: CardProps = {
  imageWhite: '322f0749-8985-48f8-b659-339900dbe1f0-graphic.png',
  imageDark: '14ed8cd4-7284-405f-b54c-fdd63507eb16-graphic.png',
  hover: '#049BFF',
  url: '/reports/customreport',
  isExternal: true,
  codeModule: 'PERFORMANCE',
  codeSubModule: 'COMPETENCES',
  translationKey: 'PERFORMANCE_COMPETENCES',
};

export const performanceFeedbackModule: CardProps = {
  imageWhite: '4fc53e11-b502-4484-8b5a-425979ce8fc3-graphic-2.png',
  imageDark: '3d0f7692-3956-47b1-9275-13d30dc9eea8-graphic-2.png',
  hover: '#049BFF',
  url: '/company/feedback',
  isExternal: true,
  codeModule: 'PERFORMANCE',
  codeSubModule: 'FEEDBACK',
  translationKey: 'PERFORMANCE_FEEDBACK',
};

export const performancePidModule: CardProps = {
  imageWhite: '24505964-3ae5-4ac9-8366-5b6dfa90251a-frame-34345.png',
  imageDark: '1e00475b-ea03-4d99-a329-9799d09cfbad-frame-34346.png',
  inverse: true,
  hover: 'var(--color-primary-light-400)',
  url: '/company/pidadmin',
  isExternal: true,
  codeModule: 'PERFORMANCE',
  codeSubModule: 'PID',
  translationKey: 'PERFORMANCE_PID',
};

export const climateEngagementSurveyModule: CardProps = {
  imageWhite: '9650f7d5-acbe-4ec0-a428-23d9aa44cecd-graphic-1.png',
  imageDark: '4c3daef5-6aba-45ba-b34c-b9d1117698d3-graphic-1.png',
  hover: '#34D69B',
  url: '/workenvironment',
  isExternal: true,
  codeModule: 'CLIMATE_ENGAGEMENT',
  codeSubModule: 'SURVEY',
  translationKey: 'CLIMATE_SURVEY',
};

export const climateEngagementRecognitionModule: CardProps = {
  imageWhite: '3794bb42-1311-4f92-ad6a-952896645527-frame-34343.png',
  imageDark: 'd3e993f1-8974-40f0-b7e6-6e69484b0d3f-frame-34344.png',
  hover: '#34D69B',
  url: '/company/recognition',
  isExternal: true,
  codeModule: 'CLIMATE_ENGAGEMENT',
  codeSubModule: 'RECOGNITION',
  translationKey: 'CLIMATE_RECOGNITION',
};

export const learningSkillEvolutionModule: CardProps = {
  imageWhite: 'f011fcc0-ebbc-40ea-9e02-a32b50dd17c3-frame-34324.png',
  imageDark: '87c0a560-ebf8-4590-8565-995e2f628956-frame-34325.png',
  inverse: true,
  hover: 'var(--color-primary-light-400)',
  url: '/org/[slug]/panel/skill-xp-evolution/',
  codeModule: 'E-Learning',
  codeSubModule: 'ML04',
  translationKey: 'LEARNING_SKILL_EVOLUTION',
};

export const learningGroupStatisticsModule: CardProps = {
  imageWhite: 'b0afb0d7-5ff0-4f52-9a26-5c4ff461f60a-frame-34329.png',
  imageDark: '2a4dcd75-89ad-4563-ba10-2cf559cf13c3-frame-34330.png',
  inverse: true,
  hover: '#FFB200',
  url: '/org/[slug]/panel/estadisticas/grupales/',
  codeModule: 'E-Learning',
  codeSubModule: 'ML03',
  translationKey: 'LEARNING_GROUP_STATISTICS',
};

export const learningCoursesModule: CardProps = {
  imageWhite: 'ec74fbec-12af-4a28-a3af-7637068edd51-frame-34347.png',
  imageDark: '58b943b9-01d5-4c3f-92c6-7c40635631e4-frame-34348.png',
  inverse: true,
  hover: '#FFB200',
  url: '/org/[slug]/panel/content/courses/',
  codeModule: 'E-Learning',
  codeSubModule: 'ML03',
  translationKey: 'LEARNING_COURSES',
};
